export default __webpack_public_path__ + "static/media/Sandals of the Oxmal.2bd46f6f.jpg";